import { Box, Button, IconButton, InputAdornment, Pagination, PaginationItem, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material"
import React, { useEffect, useMemo, useState } from "react"
import SearchIcon from '@mui/icons-material/Search';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setIbtResultListLoading, setSelectedIbtData, setShowSidebarList } from "@modules/ibt";
import MenuIcon from '@mui/icons-material/Menu';

const IBTResultList = () => {

    const currentPage = 1
    const dispatch = useDispatch()
    const [searchText, setSearchText] = useState('')
    const [resultList, setResultList] = useState([])
    const ibtResultListLoading = useSelector((state) => state.ibt.ibtResultListLoading)
    const selectedIbtData = useSelector((state) => state.ibt.selectedIbtData)
    function createData(
        num: number,
        username: string,
        idnumber: string,
        department: string,
        quiz_status: string,
        answer_status: string
    ) {
        return { num, username, idnumber, department, quiz_status, answer_status };
    }

    const rows = Array(20).fill(null).map((_, idx) => (
        createData(idx + 1, '홍길동', '20250708', '교육학과', '미응시', '미제출')
    ));

    useEffect(() => {
        // dispatch(setIbtResultListLoading(true))
        dispatch(setSelectedIbtData(null))
    }, [])

    useEffect(() => {
        console.log('searchText: ', searchText)
    }, [searchText])

    useEffect(() => {
        if(ibtResultListLoading) {
            console.log('ibtResultListLoading: ', ibtResultListLoading)
            console.log('get result list data')

            try {
                // const response = await api.get('/ibt/result-list')
            } catch (error) {
                console.log('error: ', error)
            } finally {
                setTimeout(() => {
                    dispatch(setIbtResultListLoading(false))
                }, 1500)
            }
        }
    }, [ibtResultListLoading])

    // result list 검색
    const filteredResultList = useMemo(() => {
        if(!searchText.trim()) return resultList
        
        return resultList.filter((item) => item.title.includes(searchText))
    }, [searchText, resultList])

    const renderQuizList = () => {
        return (
            <Box id="ibt-quiz-list" sx={{ height: '100%' }}>
                <Box className='flex-center' sx={{ height: '100%' }}>
                    퀴즈를 선택해주세요.
                </Box>
            </Box>
        )
    }

    useEffect(() => {
        console.log('ibtResultListLoading: ', ibtResultListLoading)
        console.log('selectedIbtData: ', selectedIbtData)
    }, [])

    return (
        // <Box className="flex-center" sx={{ height: '100%' }}>
        //     <Box id="pre-loading" />
        // </Box>
        <>
            <Box id="ibt-menu-icon" onClick={() => dispatch(setShowSidebarList(true))}>
                <MenuIcon />
            </Box>
            { ibtResultListLoading ? <Box className='flex-center' sx={{ height: '100%' }}><Box className='ibt-loading' /></Box> : (

                <>
                    { !selectedIbtData ? (
                        renderQuizList()
                    ) : (
                        <Box id="ibt-result-list">
                            <Box className='flex-between content-section-padding'>
                                <Box>
                                    <Box className='fs-2 fw-bold'>사전모의 Test - 한자</Box>
                                    <Box className='fs-0'>2025.01.22 - 2025.03.22</Box>
                                </Box>

                                <Box>
                                    <TextField 
                                        className='txt-input-padding'
                                        // label="검색어를 입력하세요."
                                        variant="outlined"
                                        size='small' fullWidth
                                        placeholder="검색어를 입력하세요."
                                        onChange={(e) => setSearchText(e.target.value)}
                                        value={searchText}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>

                            <Box className='flex-between content-section-padding'>
                                <Box className='flex-box box-gap'>
                                    <Button className='btn-border-1' variant="outlined" size='medium'>전체</Button>
                                    <Button className='btn-border-1' variant="outlined" size='medium'>응시자</Button>
                                    <Button className='btn-border-1' variant="outlined" size='medium'>미응시자</Button>
                                    <Button className='btn-border-1' variant="outlined" size='medium'>제출자</Button>
                                    <Button className='btn-border-1' variant="outlined" size='medium'>미제출자</Button>
                                </Box>
                            </Box>

                            <Box className='content-section-padding'>
                                <TableContainer className="table-container">
                                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align='center' className="fw-bold">번호</TableCell>
                                                    <TableCell align="center" className="fw-bold">이름</TableCell>
                                                    <TableCell align="center" className="fw-bold">학번</TableCell>
                                                    <TableCell align="center" className="fw-bold">학과</TableCell>
                                                    <TableCell align="center" className="fw-bold">응시 상태</TableCell>
                                                    <TableCell align="center" className="fw-bold">답안 제출 상태</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody sx={{ cursor: 'pointer' }}>
                                                {rows.map((row) => (
                                                    <TableRow
                                                        key={row.num}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0, cursor: 'pointer' } }}
                                                        // onClick={() => navigate(`/csmsibt/usage/${row.num}`)}
                                                        
                                                    >
                                                        <TableCell align='center'>{row.num}</TableCell>
                                                        <TableCell align='center'>{row.username}</TableCell>
                                                        <TableCell align="center">{row.idnumber}</TableCell>
                                                        <TableCell align="center">{row.department}</TableCell>
                                                        <TableCell align="center" className="fw-bold text-color-red">{row.quiz_status}</TableCell>
                                                        <TableCell align="center" className="fw-bold text-color-red">{row.answer_status}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <Box className="ibt-pagination flex-center pt-5 pb-5">
                                        {/* Pagination */}
                                        <Pagination 
                                            count={10} 
                                            defaultPage={ 1 } 
                                            page={ 1 }
                                            boundaryCount={ 1 }
                                            /*
                                            renderItem={(item) => (
                                                <PaginationItem
                                                    {...item}
                                                    style={{
                                                        fontWeight: item.page === currentPage ? 'bold' : 'normal',
                                                        color: item.page === currentPage ? '#888' : '#363636'
                                                    }}
                                                />
                                            )}
                                            */
                                        />
                                    </Box>

                            </Box>
                        </Box>
                    ) }
                </>
            ) }
        </>
    )
}

export default IBTResultList